export const DEFAULT_FIELD = 'title';

export const sortFieldOptions = (options = []) =>
    [...options].sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
    );

export const mapChoicesToOptions = (
    choices = [],
    { extraFields = [], hiddenFields = new Set() } = {}
) => {
    const options = choices
        .filter(
            (choice) =>
                choice?.value != null &&
                choice.value !== '' &&
                !hiddenFields.has(choice.value)
        )
        .map((choice) => ({
            value: choice.value,
            name: choice.label ?? String(choice.value),
        }));

    const existingValues = new Set(options.map((option) => option.value));
    for (const extra of extraFields) {
        if (!existingValues.has(extra.value)) {
            options.push(extra);
        }
    }

    return sortFieldOptions(options);
};

export function resolveDefaultField(options, preferred = DEFAULT_FIELD) {
    if (!options?.length) {
        return preferred;
    }

    const hasPreferred = options.some((option) => option.value === preferred);
    return hasPreferred ? preferred : options[0].value;
}
